import { inject, observer } from 'mobx-react'
import React from 'react'
import { withTranslation } from 'react-i18next'

const SearchErrorTooltip = ({ uiStore, t }) => (
  <div id='search-error-tooltip' className='click-tooltip'>
    {t('LOCATION.NOT_FOUND')}
    <button
      className='noselect'
      onClick={() => uiStore.hideClickTooltip()}
    >
      {t('GLOBAL.OK')}
    </button>
  </div>
)

export default withTranslation()(inject('uiStore')(observer(SearchErrorTooltip)))
